import "./App.css"

import {ReadHebrewText, isSpeechPossible} from "./misc";
import {useState, useCallback} from "react";

export default function HistoryPopup({history, setHistory}) {
    const [showPopup, setShowPopup] = useState(false);

    const onSwitchLangAction = useCallback((index) => {
        history[index].index = 3 - history[index].index;
        setHistory([...history]);
    }, [history]);
    const onAudioAction = (index) => {
        ReadHebrewText(history[index].textWithVowels)
    }
    // Fonction de fermeture du popup
    const closePopup = () => setShowPopup(false);

    return (
        <div>
            <button className={"history-button"} onClick={() => setShowPopup(true)}>
                📜
            </button>

            {showPopup && (
                <div className="history-popup-container" style={{zIndex: 1000}} onClick={closePopup}>
                    <div className="history-popup-wrapper">
                        {history.map((entry, index) => (
                            <div className="history-popup-row" key={index}>
                                <div className={"history-reveal-div"} onClick={(e) => {
                                    onSwitchLangAction(index);
                                    e.stopPropagation();
                                }}>
                                    🔁
                                </div>
                                <div className="history-popup-text"
                                     onClick={(e) => {
                                         onAudioAction(index);
                                         e.stopPropagation();}}
                                     dir={(entry.lang1 === "h" && entry.index === 1) || (entry.lang1 === "f" && entry.index === 2) ? "rtl" : "ltr"}
                                >
                                    {entry.index === 1 ? entry.text1 : entry.text2}</div>
                            </div>
                        ))}
                    </div>
                </div>)}
        </div>
    )
}


